import { auth } from "../services/firebase";

const baseUrl = "https://europe-west3-buchungstool-90848.cloudfunctions.net/";

export async function apiRequest(
  path: string,
  method: "GET" | "POST" | "PUT" | "DELETE",
  data?: any,
  tries = 3,
  delay = 1000
) {
  async function attempt(remaining: number): Promise<any> {
    try {
      const user = auth.currentUser;
      const token = user ? await user.getIdToken() : null;

      // For GET requests, add parameters to URL as query string
      let url = `${baseUrl}${path}`;
      if (method === "GET" && data) {
        const queryParams = new URLSearchParams();
        Object.keys(data).forEach((key) => {
          if (data[key] !== undefined && data[key] !== null) {
            queryParams.append(key, String(data[key]));
          }
        });
        const queryString = queryParams.toString();
        if (queryString) {
          url += `?${queryString}`;
        }
      }

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: method !== "GET" ? JSON.stringify(data) : undefined,
      });

      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }

      return { data: await res.json() };
    } catch (err) {
      if (remaining <= 1) throw err;
      await new Promise((r) => setTimeout(r, delay));
      return attempt(remaining - 1);
    }
  }

  return attempt(tries);
}
